const headerList = {
  "Sheer": ["Grommet Top", "Back Tab & Rod Pocket", "Double French Pinch Pleat", "Triple French Pinch Pleat", "Inverted Box Pleat", "Goblet", "Euro Pleat", "Single Rod Pocket", "Pleat Hook & Clip Rings"],
  "Curtain": ["Grommet Top", "Back Tab & Rod Pocket", "Double French Pinch Pleat", "Triple French Pinch Pleat", "Inverted Box Pleat", "Goblet", "Euro Pleat", "Single Rod Pocket", "Pleat Hook & Clip Rings"],
  "Soundproof": ["Grommet Top", "Back Tab & Rod Pocket", "Single Rod Pocket", "Pleat Hook"]
}
var resultWidth = 0, resultLength = 0, showWidth = 0, showLength = 0, isSheer = false, isCurtain = false, isSoundproof = false, isIndoor = true;
$('.popupContainer.measurement').on('click', function () {
  setThemeGuideOpen(this, false);
})

$('.popupContainer.measurement .popupBox .popupTitle svg').on('click', function () {
  $(this).closest('.popupContainer').click();
})

$('.popupContainer.measurement .popupBox').on('click', function (event) {
  event.stopPropagation();
})
 
$('.popupContainer.measurement .popupBox .popupBody .step > div').on('click', function () {
  if ($(this).attr('disabled') == 'disabled') {
    return;
  }

  scrollChangeNum({
    ele: '.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList',
    direction: 'horizontal',
    num: $(this).index()
  });

  if ($(this).index() + 1 >= $('.popupContainer.measurement .popupBox .popupBody .step > div').length) {
    resultChange();
  }
  // 底部按钮展示
  $('.btnList .btns').css('display', $(this).index() + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'none' : 'flex');
  $('.btnList > .btn').css('display', $(this).index() + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'flex' : 'none');
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').on('click', function () {
  var current = $('.popupContainer.measurement .popupBox .popupBody .step > div.active');
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.index());
  var inputType = false, optionType = false;

  if (currentStep.find('.option:not([col="1"])').length > 0) {
    optionType = currentStep.find('.optionItem.active').length == 0;
  }

  $.each(currentStep.find('input[required]'), function (i, item) {
    $(item).css('border-color', $(item).val().length == 0 || $(item).val() == 0 ? '#b11500' : '#1F1F1F');
    if ($(item).val().length == 0 || $(item).val() == 0) {
      inputType = true;
    }
  });

  currentStep.find('.option').css('border-color', optionType ? '#b11500' : 'transparent');

  if (inputType || optionType) {
    return;
  }

  stepChange();
})

var oldRodType = 0;
function stepChange () {
  var current = $('.popupContainer.measurement .popupBox .popupBody .step > div.active');
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.index());
  const type = $(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .option .optionItem.active`).attr('data-value');
  isSheer = isCurtain = isSoundproof = false;
  this[`is${type}`] = true;
  $('.popupContainer.measurement .popupBox .btns .btn[type="black"]').attr('href', `${window.Shopify.routes.root.slice(0, -1)}${$(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .option .optionItem.active`).attr('data-href')}`);
  $.each($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="header"] .option .optionItem'), function (i, item) {
    $(item).css('display', headerList[type].includes($(item).attr('data-value')) ? 'flex' : 'none');
  });

  // true: 有杆子; false: 无杆子;
  var isRod = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="width"] .first .optionItem.active').attr('data-value') == 'true';

  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .first .optionItem[data-value="true"]').css('display', isRod ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .first .inputList > .msg span.rodMsg').css('display', isRod && isIndoor ? 'block' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .first .inputList > .msg span.grommettopbottomMsg').css('display', !isIndoor ? 'block' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length"] .first .optionItem[data-value="false"]').css('display', isRod ? 'none' : 'flex');

  if (isRod != oldRodType) {
    $('.popupContainer.measurement .popupBox input[data-type="widthA"]').val(0);
    $('.popupContainer.measurement .popupBox input[data-type="widthB"]').val(0);
    $('.popupContainer.measurement .popupBox input[data-type="heightA"]').val(0);

    oldRodType = isRod;
  }

  if (!isRod && currentStep.find('.first').length > 0 && currentStep.find('.first').css('display') != 'none') {
    // 无杆子
    currentStep.find('.first').css('display', 'none');
    currentStep.find('.branch').css('display', 'flex');
    return;
  }

  if ($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.next().index()).attr('data-type') == 'length1' && !isIndoor) {
    current.next().next().removeAttr('disabled').click();
    $('.nextStep').attr('click-data', `SizeGuideStep${current.next().next().index() + 1}`);
  } else {
    current.next().removeAttr('disabled').click();
    $('.nextStep').attr('click-data', `SizeGuideStep${current.next().index() + 1}`);
  }

}

function scrollChangeNum (list = {
  ele, direction: 'horizontal', num: 1
}) {
  // horizontal: 水平; vertical: 垂直
  // 元素可活动范围
  var eleScroll = list.direction == 'vertical' ? $(list.ele)[0].scrollHeight : $(list.ele)[0].scrollWidth;
  // 第一个子元素大小
  var elechilrenSize = list.direction == 'vertical' ? $(list.ele).find('>*:first-of-type').outerHeight() : $(list.ele).find('>*:first-of-type').outerWidth();
  // 子元素间距
  var elechilrenSpace = (eleScroll - elechilrenSize * $(list.ele).find('>*').length) / ($(list.ele).find('>*').length - 1);

  var pre = (elechilrenSize + elechilrenSpace) * list.num;

  if (list.direction == 'vertical') {
    $(list.ele).animate({
      scrollTop: pre
    }, {
      duration: 150,
    });
  } else {
    $(list.ele).animate({
      scrollLeft: pre
    }, {
      duration: 150,
    });
  }

  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.first').css('display', 'flex');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.branch').css('display', 'none');

  $('.popupContainer.measurement .popupBox .popupBody .step > div').removeClass('active');
  $('.popupContainer.measurement .popupBox .popupBody .step > div').eq(list.num).removeAttr('disabled').addClass('active');
}

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('change', function () {
  $(this).val(Math.round(Math.abs($(this).val())));
})

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('keydown', function () {
  if (event.which == 13) {
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').click();
  }
})

$('.popupContainer.measurement .popupBox .btns .btn').on('click', function () {
  var type = $(this).attr('type');

  if (type == 'white') {
    // reset
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .optionItem').removeClass('active');
    $('.popupContainer.measurement .popupBox input').val('');
    $('.popupContainer.measurement .popupBox .popupBody .step > div:not(:first-of-type)').removeClass('active').attr('disabled', true);
    $('.popupContainer.measurement .popupBox .popupBody .step > div:first-of-type').click();
  }

  if (type == 'black' && $('.outChangeMsg').css('display') == 'none') {
    // shop now
  }
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .option .optionItem .itemBox').on('click', function () {
  $(this).closest('.option').css('border-color', 'transparent');
  $(this).closest('.option').find('.optionItem').removeClass('active');
  $(this).parent().addClass('active');
})

function resultChange () {
  var windowWidth = 0, windowLength = 0;
  var minWidth = 20, maxWidth = 200, minLength = 20, maxLength = 200;

  const fullnessList = {
    "Grommet Top": 1.5,
    "Grommet Top — Silver Ring": 1.5,
    "Grommet Top — Silver Rings": 1.5,
    "Grommet Top Bottom": 1.5,
    "Grommet Top Bottom - Silver Ring": 1.5,

    "Velcro Tab Top": 1.2,
    "Tab Top": 1.2,

    "Back Tab & Rod Pocket": 1.5,
    "Single Rod Pocket": 1.5,
    "Double Rod Pocket": 1.5,
    "Double Rod Pockets": 1.5,

    "Double French Pinch Pleat": 1.1,
    "Triple French Pinch Pleat": 1.1,
    "Inverted Box Pleat": 1.1,
    "Goblet": 1.1,
    "Euro Pleat": 1.1,
    "Pleat Hook & Clip Rings": 1.5,
    "Pleat Hook": 1.5
  };
  const fullnessTypeList = ["Back Tab & Rod Pocket", "Single Rod Pocket", "Double Rod Pocket", "Double Rod Pockets"];

  const rollList = {
    "Grommet Top": 2,
    "Grommet Top — Silver Rings": 2,
    "Grommet Top Bottom": 5,

    "Velcro Tab Top": 1,
    "Tab Top": 1,

    "Back Tab & Rod Pocket": 1,
    "Single Rod Pocket": 1,
    "Double Rod Pocket": 2,
    "Double Rod Pockets": 2,

    "Double French Pinch Pleat": -1,
    "Triple French Pinch Pleat": -1,
    "Inverted Box Pleat": -1,
    "Goblet": -1,
    "Euro Pleat": -1,
    "Pleat Hook & Clip Rings": -1,
    "Pleat Hook": -1
  }
  const rollTypeList = ["Double Rod Pocket", "Double Rod Pockets"];

  var header = $(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="header"] .option .optionItem.active`).attr('data-value');
  var width = parseInt($('.popupContainer.measurement .popupBox input[data-type="width"]').val() || 0),
    widthA = parseInt($('.popupContainer.measurement .popupBox input[data-type="width_A"]').val() || 0),
    widthB = parseInt($('.popupContainer.measurement .popupBox input[data-type="width_B"]').val() || 0);
  var height = parseInt($('.popupContainer.measurement .popupBox input[data-type="height"]').val() || 0),
    heightA = parseInt($('.popupContainer.measurement .popupBox input[data-type="height_A"]').val() || 0);

  var fullness = fullnessList[header];
  if (fullnessTypeList.includes(header) && (isSoundproof || isSheer)) {
    fullness = isSoundproof ? 1.2 : isSheer ? 2 : 1.5;
  }
  var type = $(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .option .optionItem.active`).attr('data-value');
  const newFullnessList = {
    "Sheer": {
      "Pleat Hook & Clip Rings": 2
    },
    "Curtain": {
      "Pleat Hook & Clip Rings": 1.8
    },
    "Soundproof": {
      "Pleat Hook": 1.6
    }
  }
  if (typeof newFullnessList !== 'undefined' && newFullnessList[type] && newFullnessList[type][header] !== undefined) {
    fullness = newFullnessList[type][header];
  }
  var roll = rollList[header];
  if (rollTypeList.includes(header) && !isSoundproof) {
    roll = 2;
  }
  var curtainType = 0;
  var curtainPanel = parseInt($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="panel"] .optionItem.active').attr('data-value'));

  if ($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length1"] .optionItem.active').attr('data-value') != undefined) {
    curtainType = parseInt($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length1"] .optionItem.active').attr('data-value'));
  }

  if (window.Shopify.routes.root != '/') {
    roll = Math.ceil(roll * window.Shopify.currency.lengthRate);
    curtainType = Math.ceil(curtainType * window.Shopify.currency.lengthRate);
    minWidth = Math.ceil(minWidth * window.Shopify.currency.lengthRate);
    maxWidth = Math.ceil(maxWidth * window.Shopify.currency.lengthRate);
    minLength = Math.ceil(minLength * window.Shopify.currency.lengthRate);
    maxLength = Math.ceil(maxLength * window.Shopify.currency.lengthRate);
  }
  var isRod = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="width"] .first .optionItem.active').attr('data-value') == 'true';
  if(!isRod){
    windowWidth = width + widthA + widthB;
  }else{
    windowWidth = width;
  }

  windowLength = height + heightA;
  resultWidth = showWidth = Math.ceil(windowWidth * fullness / curtainPanel);
  resultLength = showLength = windowLength + roll + curtainType;

  if (window.Shopify.routes.root != '/') {
    resultWidth = Math.ceil(resultWidth / window.Shopify.currency.lengthRate);
    resultLength = Math.ceil(resultLength / window.Shopify.currency.lengthRate);
  }

  var sizeText = '';
  var sizeNum = '';

  if (showWidth > maxWidth || showWidth < minWidth) {
    sizeText = 'width';
    sizeNum = `${showWidth}${ window.Shopify.currency.lengthUnit }`;
  }
  if (showLength > maxLength || showLength < minLength) {
    sizeText = 'length';
    sizeNum = `${showLength}${ window.Shopify.currency.lengthUnit }`;
  }
  if ((showWidth > maxWidth || showWidth < minWidth) && (showLength > maxLength || showLength < minLength)) {
    sizeText = 'size';
    sizeNum = `${showWidth}${ window.Shopify.currency.lengthUnit } * ${showLength}${ window.Shopify.currency.lengthUnit }`;
  }

  var arr = {
    "collections": $(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .option .optionItem.active`).attr('data-value'),
    "isRod": $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="width"] .first .optionItem.active').attr('data-value'),
    "header": header,
    "width": width,
    "widthA": widthA,
    "widthB": widthB,
    "height": height,
    "heightA": heightA,
    "length1": $('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="length1"] .optionItem.active').attr('data-value'),
    "panel": $('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="panel"] .optionItem.active').attr('data-value')
  };

  localStorage.setItem("measurementGuide", JSON.stringify(arr));

  $('.popupContainer .popupBox .popupBody .stepContainer .btnList .btns .btn[type=black]').attr('disabled', sizeNum != '');
  if (curtainType != 0) {
    $('.resultTitle').html(`Based on your selected header style ${header} (fullness ${fullness}x), rod size, and finished length (${curtainType > 0 ? 'puddle' : 'hover'}), our recommended order details for ${$(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .option .optionItem.active`).attr('data-value')} are as follows:`);
  } else {
    $('.resultTitle').html(`Based on your selected header style ${header} (fullness ${fullness}x), rod size, and finished length, our recommended order details for ${$(`.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="collections"] .option .optionItem.active`).attr('data-value')} are as follows:`);
  }

  $('.outChangeMsg').html(`Your curtain ${sizeText} (${sizeNum}) exceeds the maximum custom ${sizeText} listed on the product page. No worries — please email our team at <a href="mailto: support@thehues.com">support@thehues.com</a> for a solution.`).css('display', sizeNum != '' ? 'block' : 'none');
  $('.resultSize').html(`<p><span>${curtainPanel}</span>PANEL${curtainPanel > 1 ? 'S' : ''}</p><p><span>${showWidth}${ window.Shopify.currency.lengthUnit }</span>WIDE PER PANEL</p><p><span>${showLength}${ window.Shopify.currency.lengthUnit }</span>LONG PER PANEL</p>`);
}

$(document).ready(function () {
  if (localStorage.getItem('measurementGuide')) {
    const option = JSON.parse(localStorage.getItem('measurementGuide'));
    const collType = {
      'Sheer': 'Sheer Curtains',
      'Curtain': "Custom Curtains",
      'Soundproof': "Soundproof Curtains"
    }
    const type = product.collections.filter(item => {
      return item.title == collType[option.collections];
    }).length > 0;

    if (type) {
      $.each(Object.keys(option), function (i, item) {
        if ($(`.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="${item}"] .optionItem[data-value="${option[item]}"]`).length > 0) {
          $(`.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="${item}"] .optionItem[data-value="${option[item]}"] .itemBox`).click();
        } else {
          $(`.popupContainer .popupBox .popupBody .stepContainer .stepList input[data-type="${item}"]`).val(option[item]);
        }
        if ($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox.active').attr('data-type') != 'result') {
          $('.popupContainer .popupBox .popupBody .stepContainer .nextStep').click();
        } else {
          $('.popupContainer .popupBox .popupBody .stepContainer .btnList .btns .btn[type=black]').click();
        }
      });
      $(`.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="width"] .optionItem[data-value="${option.isRod}"] .itemBox`).click();
    }
  }
})
